import React, { useState } from 'react';
import { useNavigation } from './NavigationContext';
import { navigationData } from '../../data/navigationData';
import { NavigationItem } from '../../types/navigation';
import './GlobalNavigation.css';

const GlobalNavigation: React.FC = () => {
  const { state, updateState, toggleMobileMenu, closeMobileMenu } = useNavigation();
  const [searchQuery, setSearchQuery] = useState('');

  const handleGlobalNavigation = (item: NavigationItem) => {
    const path = item.href.split('/')[1] || 'home';
    
    updateState({
      section: path,
      product: null,
      page: null,
      path: item.href,
      mobileMenuOpen: false
    });
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simple search implementation
    if (searchQuery.toLowerCase().includes('finance')) {
      updateState({
        section: 'pros',
        product: 'finance',
        page: 'overview',
        path: '/pros/finance'
      });
    } else if (searchQuery.toLowerCase().includes('leads')) {
      updateState({
        section: 'pros',
        product: 'leads',
        page: 'overview',
        path: '/pros/leads'
      });
    }
    setSearchQuery('');
  };

  return (
    <nav className="global-nav" role="navigation" aria-label="Main navigation">
      <div className="container">
        <div className="nav-content">
          {/* Brand Logo */}
          <div className="nav-brand">
            <a 
              href="/" 
              className="brand-link" 
              aria-label="Modernize Home"
              onClick={(e) => {
                e.preventDefault();
                handleGlobalNavigation({ label: "Home", href: "/" });
              }}
            >
              <div className="brand-logo">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="8" fill="var(--color-primary)"/>
                  <path d="M8 24V8h3v13h10v3H8z" fill="white"/>
                  <path d="M14 18V12h3v6h-3z" fill="white"/>
                  <path d="M20 20V10h3v10h-3z" fill="white"/>
                </svg>
              </div>
              <span className="brand-text">{navigationData.global.brand}</span>
            </a>
          </div>

          {/* Main Navigation Items */}
          <div className="nav-items">
            {navigationData.global.items.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`nav-item ${state.section === item.href.split('/')[1] ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleGlobalNavigation(item);
                }}
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Search */}
          <div className="nav-search">
            <form className="search-wrapper" onSubmit={handleSearchSubmit}>
              <input
                type="search"
                className="search-input"
                placeholder="Search..."
                aria-label="Search"
                value={searchQuery}
                onChange={handleSearch}
              />
              <button type="submit" className="search-btn" aria-label="Search">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10zM13 13l-3.35-3.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </form>
          </div>

          {/* CTA Buttons */}
          <div className="nav-cta">
            {navigationData.global.cta.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`btn ${item.primary ? 'btn--primary' : 'btn--outline'} btn--sm`}
                onClick={(e) => {
                  e.preventDefault();
                  handleGlobalNavigation(item);
                }}
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className={`mobile-menu-toggle ${state.mobileMenuOpen ? 'active' : ''}`}
            aria-label="Toggle mobile menu"
            aria-expanded={state.mobileMenuOpen}
            onClick={toggleMobileMenu}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default GlobalNavigation;